import { WhiteLabel } from "@/models/whiteLabel.model";
import { AxiosError } from "axios";
import { axiosInstance } from "./axiosInstance";
type getAllPendingWhiteLabelsType = {
  data: WhiteLabel[];
  totalPages: number;
};

export const fetchWhiteLabel = async (
  slug: string | null
): Promise<WhiteLabel | null> => {
  try {
    if (slug) {
      const response = await axiosInstance.get<WhiteLabel>("/api/whitelabel/", {
        params: { slug },
      });
      return response.data;
    }
    return null;
  } catch (error) {
    console.error("Error fetching white label data:", error);
    if (error instanceof AxiosError && error.response?.status === 404) {
      return null;
    }
    throw error;
  }
};

export const createWhiteLabel = async (data: any): Promise<WhiteLabel> => {
  try {
    const response = await axiosInstance.post<WhiteLabel>("/api/admin/whitelabel", {
      ...data,
    });
    return response.data;
  } catch (error) {
    console.error("Error creating white label:", error);
    throw error;
  }
};

export const updateWhiteLabel = async (
  id: string,
  data: any
): Promise<WhiteLabel> => {
  try {
    const response = await axiosInstance.put<WhiteLabel>(
      `/api/admin/whitelabel/${id}`, {
        ...data,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating white label:", error);
    throw error;
  }
};

export const checkWhitelabel = async (
  slug: string | null
): Promise<WhiteLabel | null> => {
  try {
    if (slug) {
      const response = await axiosInstance.get<WhiteLabel>(
        `/api/whitelabel/${slug}/exists`
      );
      return response.data;
    }
    return null;
  } catch (error) {
    console.error("Error fetching white label data:", error);
    if (error instanceof AxiosError && error.response?.status === 404) {
      return null;
    }
    throw error;
  }
};

export const getAllPendingWhiteLabels = async (
  page: number,
  pageSize: number,
  sortOrder: "asc" | "desc" = "desc"
): Promise<getAllPendingWhiteLabelsType> => {
  try {
    const response = await axiosInstance.get<getAllPendingWhiteLabelsType>(
      "/api/whitelabel/pending",
      {
        params: {
          page,
          pageSize,
          sortOrder,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching pending WhiteLabels:", error);
    throw error;
  }
};
export const getCountPendingWhiteLabels = async (): Promise<number> => {
  try {
    const response = await axiosInstance.get<number>(
      "/api/whitelabel/count/pending"
    );
  
    return response.data;
  } catch (error) {
    console.error("Error fetching pending WhiteLabels:", error);
    throw error;
  }
};



export const approveWhiteLabel = async (id: string): Promise<void> => {
  try {
    await axiosInstance.post(`/api/whitelabel/approve/${id}`);
  } catch (error) {
    console.error("Error approving white label:", error);
    throw error;
  }
};

export const rejectWhiteLabel = async (id: string) => {
  const response = await axiosInstance.post(`/api/whitelabel/reject/${id}`);
  return response.data;
};
